<template></template>
<script>
export default {
  name: "ConferenceRoomShow",
  props: {
    conferenceRoomUuid: {
      default: null,
      type: String,
    },
  },
  methods: {
    fetchConferenceRooms() {
      this.$store.dispatch("fetchConferenceRooms")
    },
    fetchConferenceStands() {
      this.$store.dispatch("fetchConferenceStands")
    },
    fetchConferenceRoomUsers() {
      this.$store.dispatch("fetchConferenceRoomUsers")
    },
    fetchConferenceRoomStands() {
      this.$store.dispatch("fetchConferenceRoomStands")
    },
  },
  created() {
    this.$store.commit("setConferenceRoomUuid", this.conferenceRoomUuid)
    this.fetchConferenceRooms()
    this.fetchConferenceStands()
    this.fetchConferenceRoomUsers()
    this.fetchConferenceRoomStands()
  },
}
</script>
